/**
 * La marca «posible» de una relación con la lista bajo una fila del buscador (`siger.links`, decisión de Bernardo del 2026-10-04: se
 * siguen listando las relaciones cuyo ancla del acta no está corroborada, con esta marca) y su ayuda. Textos aprobados por Bernardo el
 * 2026-10-04 (bitácora 2026-10-03-etapa4-piezas.md, «Aprobación de la matriz completa…»).
 *
 * Corte 4c: antes vivían dentro de un componente de Argus Team (SubjectSearch.tsx, en `Registry`, que la ficha nueva ya no pinta y se
 * retiró) con una copia vigilada en Nexo (nexo-frontend/src/ficha/buscador.ts). Ahora el dueño es éste y Nexo lo importa.
 */
export const MARCA_POSIBLE = 'posible';
export const MARCA_POSIBLE_AYUDA = 'La persona o empresa del acta del Registro Público de Comercio puede no ser la de la lista de OFAC.';

/**
 * Corte 2c de los certificados del SAT (Bernardo, 2026-10-17: «¿No se pueden poner todas las relaciones? Ser socio es relevante tmb»):
 * las otras relaciones de una fila del buscador (`relaciones` de nexo.buscar_sujetos), debajo de la principal. Aprobados por Bernardo el
 * 2026-10-17 («Ok. Cuando esté, si está en verde, merge», por la coordinadora); «terminada» ya estaba aprobado (la fila lo decía en línea).
 */
export const RELACIONES_FILA = {
  titulo: 'Otras relaciones',
  terminada: 'ya no vigente según el Registro Público de Comercio',
  certificado: 'según un certificado del SAT de {anio}',
  mas: 'y {n} más; están en la ficha',
} as const;

/**
 * 4d (Bernardo, 2026-10-05, ajuste 3: «pestañas de búsquedas para ver varias personas», como Sayari). Cada pestaña es una búsqueda:
 * su nombre es lo buscado; una pestaña vacía se llama «Nueva búsqueda». Por aprobar; siguen el patrón de los botones que dicen lo que
 * hacen («Ver la ficha», «Pantalla completa») y el nombre accesible con «: [de qué]» de «Ver la fuente: [de quién]».
 */
/**
 * 0.9.1 (revisión): bajo un grupo del buscador con varias personas o empresas encontradas que no están unidas. Antes, escrito dentro de
 * SubjectSearch.tsx. El de personas, como estaba; el de empresas, por aprobar (una empresa no tiene CURP ni fecha de nacimiento).
 */
export const NO_SE_UNIERON = {
  personas: 'Las personas encontradas no se unieron solas: les falta un RFC, CURP o fecha de nacimiento en común.',
  empresas: 'Las empresas encontradas no se unieron solas: les falta un RFC o una fecha de constitución en común.',
} as const;

/**
 * Modo Buscador, lote 2a (texto aprobado en los bocetos, docs/producto/prototipos/modo-buscador-textos.html, BU-11): la fila entró porque
 * todas las palabras del nombre de la fuente están en lo buscado, pero la fuente tiene menos palabras («Juan Pérez» de la lista cuando se
 * buscó «Juan Carlos Pérez López»).
 */
export const FALTAN_PALABRAS = 'a la fuente le faltan palabras';

export const BUSQUEDAS = {
  /** Nombre de la lista de pestañas (lector de pantalla). */
  busquedas: 'Búsquedas',
  /** Una pestaña sin búsqueda todavía, y el botón «+». */
  nuevaBusqueda: 'Nueva búsqueda',
  /** El botón «×» de cada pestaña: su título, y su nombre accesible con lo buscado (o «Nueva búsqueda»). */
  cerrarBusqueda: 'Cerrar búsqueda',
  cerrarBusquedaDe: 'Cerrar búsqueda: {nombre}',
  /** Con el límite de pestañas abiertas. */
  limite: 'Puedes tener hasta {n} búsquedas abiertas. Cierra una para abrir otra.',
  /**
   * 0.9.1 (Bernardo, 2026-10-06; por aprobar): con la ficha abierta, los resultados toman un tercio; este botón deja la ficha a todo el
   * ancho de la búsqueda (para ver la red completa) y «Volver a los resultados» la regresa.
   */
  ampliarFicha: 'Ampliar la ficha',
} as const;
